import PropTypes from 'prop-types';

import MillesimaLink from '@/components/common/MillesimaLink';
import { formatUrl, getHrefForCategLink } from '@/utils/linkUtils';

import styles from './FooterProductPageDynamicLinks.module.scss';

const FooterProductPageDynamicLinks = ({ title, dynamicLinks, isMobile = false, storeConf }) => dynamicLinks?.length > 0 ? (
  <div>
    <div className={`${styles.title}${isMobile ? ' ' + styles.mobile : ''}`} data-test-id="title">
      {title}
    </div>
    <div className={styles.content} data-rbf="footer-product-page">
      {dynamicLinks.map(({ id, name, url, isSpirit }) => (
        <MillesimaLink
          key={id}
          id={id}
          type="inline-link"
          href={getHrefForCategLink(url, id, isSpirit)}
          as={formatUrl(url, isSpirit, storeConf)}
          ariaLabel={name}
          innerHtml={name}
          customClassName={{ container: styles.link }} />
      ))}
    </div>
  </div>
) : null;

FooterProductPageDynamicLinks.propTypes = {
  title: PropTypes.string,
  isMobile: PropTypes.bool,
  dynamicLinks: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })),
  storeConf: PropTypes.object
};

export default FooterProductPageDynamicLinks;
